import { CustomConfirmationComponentProps } from "../../types";
import { Text } from "@mantine/core";
import { labelMappings } from "../../utils/utils";

export const CustomConfirmationComponent: React.FC<CustomConfirmationComponentProps> = ({ couponId, couponName }) => {
    return (
        <div style={{marginTop:"-4%",marginBottom:"2%"}}>
           <Text
              size="xl"
              align="center"
              sx={() => ({
                fontSize: "16px"
              })}
            >
             <b>{labelMappings["coupon-id-liveCoupon"]}: </b> {couponId}
            </Text>
            <Text
              size="xl"
              align="center"
              sx={() => ({
                fontSize: "16px",
              })}
            >
             <b>{labelMappings["coupon-title-liveOptions"]}: </b>{couponName}
            </Text>
        </div>
    );
};